export const unwrapDataResponse = <T>(responseData: unknown): T => {
  if (
    responseData &&
    typeof responseData === 'object' &&
    'statusCode' in responseData &&
    'data' in responseData
  ) {
    return (responseData as { data: T }).data;
  }

  return responseData as T;
};
